<template>
<div>
    <v-layout wrap   style="text-align: center" justify-center>

        <!-- <v-divider vertical></v-divider> -->
        <v-flex xs12 sm12 md4 lg4>
            <v-card :style="{'borderRadius': '0px', 'border-right': '1px solid lightgrey', 'height': cardHeight+'px'}" flat ref="primaryContact">
                <v-card-title>Primary Contact</v-card-title>
                <v-card-subtitle style="text-align: left; fontSize: 12px">This person will be the main contact and should be available to schedule an installation appointment.</v-card-subtitle>

                <v-card-text>
                    <v-layout wrap   justify-center style="margin:0; padding: 0px">
                        <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                            <v-select  v-model="detail.primaryContact.title" :items="titles" :rules="titleRules" label="Title*">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                            <v-text-field class="input-flex-min-space" v-model="detail.primaryContact.idNumber" :rules="idNumberRules" label="ID Number*">
                            </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                            <v-text-field  label="Name*" :rules="nameRules" v-model="detail.primaryContact.firstName"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                            <v-text-field  label="Surname*" :rules="surnameRules" v-model="detail.primaryContact.lastName"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                            <v-text-field append-icon="call"  label="Contact Number*" :rules="contactNumberRules" v-model="detail.primaryContact.contactNumber"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                            <v-text-field append-icon="email"  label="Email Address*" @change="contactVerified=false, firstOtp=0" :rules="emailRules" v-model="detail.primaryContact.emailAddress"></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs12 sm12 style="margin:0; padding: 2px; text-align: center">
                            <v-layout wrap   justify-center v-if="!contactVerified">
                                <v-flex xs12 style="text-align: center">
                                    <v-icon color="orange" class="px-2">error</v-icon>
                                    <span v-if="!verifyResult">Email verification required</span>
                                    <span v-else>{{verifyResult}}</span>
                                </v-flex>
                            </v-layout >
                            <v-layout wrap   justify-center v-else>
                                <v-flex xs12 style="text-align: center">
                                    <span>
                                        <v-icon class="px-2" color="light-green">check_circle_outline</v-icon>Email verifiied
                                    </span>
                                </v-flex>
                            </v-layout >
                        </v-flex> -->
                        <!-- <v-flex xs12 style="text-align: center" v-if="!emailSent&&!contactVerified">
                            <span style="color: grey;text-align: left; fontSize: 12px">
                                In order to complete the process of capturing your contact details, we first need to verify your email address. Click the below button to send a One-Time Pin (OTP) to the above email address:
                            </span> <br>
                            <v-btn v-if="firstOtp == 0" small class=" mt-2" :disabled="!validateEmail()" @click="sendOtp(detail.primaryContact.emailAddress)" color="primary" rounded>Send OTP<v-icon class="ml-1" small color="white">email</v-icon>
                            </v-btn>

                        </v-flex>
                        <v-flex xs12 style="text-align: center" v-if="emailSent&&!contactVerified">
                            <span style="color: grey">
                                We have sent a 4-digit code to
                                <b>{{ detail.primaryContact.emailAddress }}</b>. Please check in your spam folder if not found.
                            </span>
                            <br>
                            <span>Didn't receive the pin? <a @click="sendOtp(detail.primaryContact.emailAddress)">Resend now</a></span>
                        </v-flex> -->
                        <!-- <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">

                            <v-layout wrap   class="justify-center">
                                <v-otp-input v-if="firstOtp>0&&!contactVerified" ref="otpInput" separator="-" input-classes="otp-input" :num-inputs="4" :is-input-num="true" @on-complete="onComplete($event)" />
                            </v-layout >
                        </v-flex> -->
                    </v-layout >

                </v-card-text>
            </v-card>
        </v-flex>

        <!-- <v-divider inset vertical></v-divider> -->
        <v-flex xs12 sm12 md4 lg4>
            <v-card flat :style="{'borderRadius': '0px', 'border-right': '1px solid lightgrey', 'height': cardHeight+'px'}" ref="secondaryContact">
                <v-card-title>Secondary Contact <i style="fontSize: 18px; margin-left: 3px"> (Optional)</i>
                    <v-spacer></v-spacer>
                    <v-icon v-if="showSecondaryInfo" @click="showSecondaryInfo=false,detail.secondaryContact=null" color="red">remove_circle_outline</v-icon>
                </v-card-title>
                <v-card-subtitle style="text-align: left; fontSize: 12px">This person will only be contacted in the event of the Primary Contact being unavailable, but who can still make account changes.</v-card-subtitle>
                <v-card-text>
                    <v-btn color="primary" rounded outlined v-if="!showSecondaryInfo" @click="detail.secondaryContact={},showSecondaryInfo=true">
                        <v-icon>add</v-icon> Add Contact
                    </v-btn>
                    <div v-if="showSecondaryInfo">
                        <v-layout wrap   justify-center style="margin:0; padding: 0px">
                            <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                <v-select  v-model="detail.secondaryContact.title" :items="titles" :rules="titleRules" label="Title*">
                                </v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                <!-- <v-text-field 
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.idNumber"
                                    :rules="idNumberRules"
                                    label="ID Number*"
                                  >
                                  </v-text-field> -->
                            </v-flex>
                            <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                <v-text-field  label="Name" :rules="nameRules" v-model="detail.secondaryContact.firstName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                <v-text-field  label="Surname" :rules="surnameRules" v-model="detail.secondaryContact.lastName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                <v-text-field append-icon="call"  label="Contact Number" :rules="contactNumberRules" v-model="detail.secondaryContact.contactNumber"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                <v-text-field append-icon="email"  label="Email Address" :rules="emailRules" v-model="detail.secondaryContact.emailAddress"></v-text-field>
                            </v-flex>
                        </v-layout >
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm12 md4 lg4>
            <v-card flat ref="billingContact" :style="{'borderRadius': '0px', 'border-right': '1px solid lightgrey'}">
                <v-card-title>Billing Contact<i style="fontSize: 18px; margin-left: 3px"> (Optional)</i>
                    <v-spacer></v-spacer>
                    <v-icon v-if="showBillingInfo" @click="showBillingInfo=false,detail.billingContact=null" color="red">remove_circle_outline</v-icon>
                </v-card-title>
                <v-card-subtitle style="text-align: left; fontSize: 12px">This is the person we contact regarding any required payments. 
                    <!-- <br /> <i>P.S. Only add this info if it isn't the same as the primary contact. </i> -->
                    </v-card-subtitle>
                <v-card-text>
                    <v-btn color="primary" rounded outlined v-if="!showBillingInfo" @click="detail.billingContact={},showBillingInfo=true">
                        <v-icon>add</v-icon> Add Contact
                    </v-btn>
                    <div v-if="showBillingInfo">
                        <v-layout wrap   justify-center style="margin:0; padding: 0px">
                            <v-flex xs12>
                                <v-btn-toggle v-model="detail.isOrganisation" rounded color="primary" class="black--text" small>
                                    <v-btn small class="black--text" :value="false">
                                        <v-icon style="mr-2">account_circle</v-icon> Person
                                    </v-btn>
                                    <v-btn small class="black--text" :value="true">
                                        <v-icon style="mr-2">business</v-icon> Company
                                    </v-btn>
                                </v-btn-toggle>

                            </v-flex>
                            <div v-if="!detail.isOrganisation">
                                <v-layout wrap   justify-center style="margin:0; padding: 0px">
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 0px">
                                        <v-select  v-model="detail.billingContact.title" :items="titles" @change="checkProceedToSummary()" :rules="titleRules" label="Title*">
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 0px">
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 0px">
                                        <v-text-field  label="Name" :rules="nameRules" v-model="detail.billingContact.firstName"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                        <v-text-field  label="Surname" :rules="surnameRules" v-model="detail.billingContact.lastName"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                        <v-text-field append-icon="call"  label="Contact Number" :rules="contactNumberRules" v-model="detail.billingContact.contactNumber"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                        <v-text-field append-icon="email"  label="Email Address" :rules="emailRules" v-model="detail.billingContact.emailAddress"></v-text-field>
                                    </v-flex>
                                </v-layout >
                            </div>
                            <div v-else>
                                <v-layout wrap   justify-center style="margin:0; padding: 0px">
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                        <v-text-field  label="Contact Person: Name" :rules="nameRules" v-model="detail.billingContact.firstName"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                        <v-text-field  label="Contact Person: Surname" v-model="detail.billingContact.lastName"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                        <v-text-field  label="Registered Name" :rules="nameRules" v-model="detail.organisationName"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md10 style="margin:0; padding: 2px">
                                        <v-text-field  label="VAT Number" v-model="detail.billingContact.vatNumber"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 style="margin:0; padding: 2px">
                                        <h3 style="text-align: center">Billing Address</h3>
                                        <v-text-field class='mt-1'  v-model="detail.billingContact.physicalAddressLine1"></v-text-field>
                                        <v-text-field class='mt-1'  v-model="detail.billingContact.physicalAddressLine2"></v-text-field>
                                        <v-text-field class='mt-1'  v-model="detail.billingContact.physicalAddressLine3"></v-text-field>

                                    </v-flex>

                                </v-layout >
                            </div>

                        </v-layout >
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 style=" margin-top:0;margin-bottom:0; padding-top:0;padding-bottom:0;">
            <v-layout wrap   style="margin-left: 20px; margin-right: 20px; margin-top:0;margin-bottom:0; padding-top:0;padding-bottom:5px;">
                <v-btn rounded color="primary" @click="back()">
                    <v-icon>chevron_left</v-icon> Back
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="!showOfInterest" rounded color="primary" :disabled="!validateAllContacts" @click="proceed()"> Next <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn v-else rounded color="primary" :disabled="!validateAllContacts" @click="submitShowOfInterest()"> Submit Show of Interest
                </v-btn>
            </v-layout >

        </v-flex>
    </v-layout >
</div>
</template>

<script>
import Api from "@/services/Api.js";
export default {
    props: ['detail', 'showOfInterest'],
    data() {
        return {
            cardHeight: 600,
            contactVerified: false,
            emailSent: false,
            firstOtp: 0,
            keyEmail: 0,
            showBillingInfo: false,
            showSecondaryInfo: false,
            verifyResult: '',
            // Rules
            dateRules: [(v) => !!v || "Date is required"],
            nameRules: [(v) => !!v || "Name is required"],
            surnameRules: [(v) => !!v || "Last Name is required"],
            contactNumberRules: [
                (v) => !!v || "Contact Number is required",
                (v) => (v && v.length > 9) || "Contact Number should be 10 digits",
            ],
            idNumberRules: [
                (v) => !!v || "ID Number is required",
                (v) => (v && v.length > 8) || "Please Enter a Valid ID Number",
            ],
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) =>
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                    v
                ) || "E-mail must be valid",
            ],
            titleRules: [(v) => !!v || "Title is required"],
            titles: ["Mr", "Mrs", "Miss", "Dr", "Prof", "Sir", "Madam", "Other"],
        }
    },
    watch: {
        showSecondaryInfo(value) {
            this.calculateHeight()
        },
        showBillingInfo(value) {
            this.calculateHeight()
        },
        'detail.isOrganisation': {
            immediate: true,
            handler(val) {
                this.calculateHeight()
            }
        }
    },
    computed: {
      validateAllContacts(){
          let result = false
          if(this.primaryContactVerified()&&!this.showSecondaryInfo&&!this.showBillingInfo){
            result = true
          }
          else if(this.showSecondaryInfo&&!this.showBillingInfo&&this.secondaryContactVerified()&&this.primaryContactVerified()){
            result = true
          }else if(this.showSecondaryInfo&&this.showBillingInfo&&this.secondaryContactVerified()&&this.billingContactVerified()&&this.primaryContactVerified()){
            result = true
          }else if(!this.showSecondaryInfo&&this.showBillingInfo&&this.billingContactVerified()&&this.primaryContactVerified()){
            result = true
          }
          return result
        }
    },
    created() {
        this.calculateHeight()
    },
    methods: {
        back() {
            this.$emit('back')
        },
        calculateHeight() {
            if(!this.$vuetify.breakpoint.xs){
                if (this.$refs.primaryContact) {
                this.cardHeight = this.$refs.primaryContact.$el.clientHeight
                if (this.$refs.secondaryContact) {
                    if (this.$refs.secondaryContact.$el.clientHeight > this.cardHeight)
                        this.cardHeight = this.$refs.secondaryContact.$el.clientHeight
                }
                if (this.$refs.billingContact) {
                    if (this.$refs.billingContact.$el.clientHeight > this.cardHeight)
                        this.cardHeight = this.$refs.billingContact.$el.clientHeight
                }
            }
            } else 
                this.cardHeight='auto'
            

        },
        onComplete(value) {
            Api()
                .post("/ftthApplication/compareOtp", {
                    otp: value,
                    emailAddress: this.detail.primaryContact.emailAddress,
                })
                .then((response) => {
                    if (response.data.result === "Email Verified") {
                        this.contactVerified = true;
                        this.verifyResult = "Verification Successful";
                        this.contactVerified = true;
                        this.keyEmail++;
                    } else if (response.data.result === "OTP Expired") {
                        this.contactVerified = false;
                        this.verifyResult = "OTP Expired";
                        this.keyEmail++;
                    } else if (response.data.result === "Verification Unsuccessful") {
                        this.contactVerified = false;
                        this.verifyResult = "Verification Unsuccessful";
                        this.keyEmail++;
                    }
                });
        },
        proceed() {
            console.log(this.detail)
            this.$emit('proceed')
        },
        submitShowOfInterest(){
            this.$emit('submitShowOfInterest')
        },
        sendOtp(email) {
            Api()
                .post("/ftthApplication/sendOtp", {
                    emailAddress: email,
                })
                .then((response) => {
                    this.otp = response.data.result;
                    this.firstOtp++;
                    this.emailSent = true;
                });
        },
        validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateEmail() {
            if (
                this.detail.primaryContact.emailAddress != null &&
                this.detail.primaryContact.emailAddress != "" &&
                this.validEmail(this.detail.primaryContact.emailAddress)
            ) {
                return true;
            } else {
                return false;
            }
        },
        primaryContactVerified(){
          return this.detail.primaryContact.title && this.detail.primaryContact.firstName && this.detail.primaryContact.lastName&&
          this.detail.primaryContact.idNumber&&this.detail.primaryContact.contactNumber&&this.detail.primaryContact.emailAddress
        },

        secondaryContactVerified(){
          return this.detail.secondaryContact.title && this.detail.primaryContact.firstName && this.detail.secondaryContact.lastName&&
          this.detail.secondaryContact.contactNumber&&this.detail.secondaryContact.emailAddress
        },
         billingContactVerified(){
          return this.detail.primaryContact.firstName && this.detail.primaryContact.lastName&&
          this.detail.primaryContact.idNumber&&this.detail.primaryContact.contactNumber&&this.detail.primaryContact.emailAddress
        },
        
    }
}
</script>

<style scoped>
.otp-input-xs {
    width: 25px;
    height: 25px;
    padding: 5px;
    margin: 0px 20px;
    font-size: 15px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
}

.otp-input-xs::-webkit-inner-spin-button,
.otp-input-xs::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0px 10px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    text-justify: center;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
